import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";

export class FulfillmentLineTypesMultiSelectComponent implements IController {

  selectedFulfillmentLineTypes: string[];
  ngPlaceholder: any;
  isDisabled: boolean;
  isRequired: boolean;
  onChange: Function;

  public selectedText: any;

  constructor(private $mdPanel, private $element) {
  }

  $onInit() {
    this._setSelectedText();
  };

  $onChanges(changes) {
    if (changes.selectedFulfillmentLineTypes && !changes.selectedFulfillmentLineTypes.isFirstChange()) {
      this._setSelectedText();
    }
  };

  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdsRef = this.selectedFulfillmentLineTypes || [];
    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-multi-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-ids="ctrl.selectedIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'query-map="ctrl.queryMapRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-multi-select-filter-panel>',
      controller: function () {
        this.typeRef = 'fulfillmentLineTypes';
        this.selectedIdsRef = selectedIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, fulfillmentLineTypes) => {
        if (fulfillmentLineTypes === 'clickOutsideToClose' || fulfillmentLineTypes === 'escapeToClose') {
          fulfillmentLineTypes = selectedIdsRef;
        }

        this.onChange({fulfillmentLineTypes: fulfillmentLineTypes});
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({fulfillmentLineTypes: []});
  }

  private _setSelectedText() {
    let string = '';
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext("2d");

    _.forEach(this.selectedFulfillmentLineTypes, (b, i) => {
      string += b;
      if ((i + 1) < this.selectedFulfillmentLineTypes.length) {
        string += ', '
      }
    });

    const stringWidth = ctx.measureText(string).width;
    if (this.$element[0]?.clientWidth && (stringWidth + 80) >= (this.$element[0].clientWidth - 30)) {
      string = this.selectedFulfillmentLineTypes[0] + ` +${this.selectedFulfillmentLineTypes.length - 1}`
    }
    this.selectedText = string;
  }


}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentLineTypesMultiSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedFulfillmentLineTypes: '<?',
      ngPlaceholder: '@?',
      isDisabled: '<?',
      isRequired: '<?',
      onChange: '&'
    },
    template: require('./fulfillment-line-types-multi-select.html').default,
    controller: FulfillmentLineTypesMultiSelectComponent
  });
